export const types = {
  UPDATE_METAFIELDS_VARIANTS: "UPDATE_METAFIELDS_VARIANTS",
  UPDATE_METAFIELDS_PRODUCTS: "UPDATE_METAFIELDS_PRODUCTS",
  UPDATE_METAFIELDS_GLOBALS: "UPDATE_METAFIELDS_GLOBALS",
};
